import { LoadingContext } from "App"
import { useContext } from "react"

export const useLoading = () => {
  const { setLoading } = useContext(LoadingContext)
  return setLoading
}
